module.exports = __webpack_public_path__ + "media/images/last-page_bg-66b3de2b18c14a0086a9ca8ee2a00194.png";